import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generateTokenUri, initializeSmart } from '../../../redux/actions/auth'
import qs from 'qs'
import { Spinner } from 'react-bootstrap'
import Layout from '../../Layouts/Layout'

const Launch = () => {
  const dispatch = useDispatch()
  const fhirAuth = useSelector((state) => state.auth)

  useEffect(() => {
    const querystring = qs.parse(window.location.search.slice(1))
    if (typeof querystring.iss === 'undefined') {
      alert('Issuer not specified. Aborting.')
      window.location = '/'
      return
    }

    if (typeof querystring.launch === 'undefined') {
      alert('Launch code not specified. Aborting.')
      window.location = '/'
      return
    }
    dispatch(initializeSmart(querystring.iss, querystring.launch))
  }, [])

  useEffect(() => {
    if (fhirAuth.redirectToTokenUri) {
      dispatch(generateTokenUri({
        iss: fhirAuth.iss,
        launch: fhirAuth.launch,
        authorizeUrl: fhirAuth.authorizeUrl,
        tokenUrl: fhirAuth.tokenUrl,
        epicVersion: fhirAuth.epicVersion
      }))
    }
  }, [fhirAuth.redirectToTokenUri])

  useEffect(() => {
    if (fhirAuth.tokenURI) {
      window.location = fhirAuth.tokenURI
    }
  }, [fhirAuth.tokenURI])

  if (fhirAuth.error !== null) {
    return <div>Error: {fhirAuth.error}</div>
  }

  return (
    <Layout showNav={false} showFooter={false}>
      <div className='text-center'>
        <Spinner animation='border' role='status' />
        <div>{fhirAuth.userFriendlyStatus}</div>
      </div>
    </Layout>
  )
}

export default Launch
